import { forwardRef, ComponentProps, ForwardedRef } from 'react';
import { CoreConditionalSelect } from '../_core';
import { defaultSelectInputStyles } from './input.styles';
import { clsx } from '../../utils';

type MultiSelectProps = ComponentProps<typeof CoreConditionalSelect>;

export const MultiSelect = forwardRef(({ sx, ...props }: MultiSelectProps, ref: ForwardedRef<HTMLElement>) => (
	<CoreConditionalSelect {...props} sx={clsx(defaultSelectInputStyles(), sx)} ref={ref} />
));

MultiSelect.displayName = 'MultiSelect';
